import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["value", "tabAll", "tabWeek", "tabMonth"]

  static values = {
    all: Number,
    week: Number,
    month: Number
  }

  connect() {
    this.showAll()
  }

  render(minutes) {
    const hours = minutes / 60
    this.valueTarget.innerText = `${hours.toFixed(1)}h`
  }

  setActive(activeTarget) {
    const tabs = [this.tabAllTarget, this.tabWeekTarget, this.tabMonthTarget]

    tabs.forEach(tab => {
      tab.classList.remove("font-fanword-bold")
    })

    activeTarget.classList.add("font-fanword-bold")
  }

  showAll() {
    this.render(this.allValue)
    this.setActive(this.tabAllTarget)
  }

  all() {
    this.showAll()
  }

  week() {
    this.render(this.weekValue)
    this.setActive(this.tabWeekTarget)
  }

  month() {
    this.render(this.monthValue)
    this.setActive(this.tabMonthTarget)
  }
}
